// extracted by mini-css-extract-plugin
module.exports = {"container":"SubscriptionPerks_container__KMgzz","perkColumn":"SubscriptionPerks_perkColumn___QfpN","perk":"SubscriptionPerks_perk__fdEQO","icon":"SubscriptionPerks_icon__aAsEi"};